import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
// src/app/app-shell.component.ts





@Component({
   imports: [
    RouterOutlet
  ],
  selector: 'app-root',
  standalone: true,
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent {}
